export enum InventoryNumberType {
  Default = 0,
  ToolsAndMaterials = 1,
  Vehicle = 2,
  VehiclePlatform = 3,
  SpecialSuperstructure = 4
}
